import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, inject, signal } from '@angular/core';
import {
    DealerFeature,
    HomeFeature,
    RouterLinkDirective,
    TrackingDirective,
    type ApiTypes,
} from '@hyundai/ng-common-lib';
import { M010C020IconLinkComponent, M040C110ModelSelectComponent } from '@hyundai/ui';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-home-page-models',
    standalone: true,
    imports: [M040C110ModelSelectComponent, RouterLinkDirective, M010C020IconLinkComponent, TrackingDirective],
    templateUrl: './home-page-models.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageModelsComponent {
    store = inject(Store);

    activeCategory = signal<string | null>(null);

    modelList = this.store.selectSignal(HomeFeature.state.selectHomeModelList);
    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);

    filteredModels = computed(() => {
        const modelList = this.modelList();
        if (!modelList) return [];

        const activeCategory = this.activeCategory() ?? modelList.categories[0];
        return modelList.models.filter((model) => model.categories.includes(activeCategory as ApiTypes.ModelCategory));
    });
}
